import React from 'react'
import styled from 'styled-components'
import { motion } from 'framer-motion'

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
  }
}

export default function Biography ({ biography }) {
  return (
   <Container variants={itemVariants}>
     <h4>Biografía</h4>
     <p>{biography}</p>
   </Container>
  )
}

const Container = styled(motion.div)`
  background: #FFFFFF;
  box-shadow: 0 2px 20px rgba(197, 217, 232, 0.5);
  border-radius: 12px;
  padding: 2.8rem;
  
  h4 {
    margin-bottom: 1.1rem;
    font-size: 1.9rem;
  }
`